module.exports = __webpack_public_path__ + "img/newsletter.126ed6c8.svg";